import { Container, Spinner } from 'react-bootstrap';
import MovieCard from '../components/MovieCard';
import Searchbar from '../components/Searchbar';
import Navigation from '../components/Navigation';
import '../styles/movies/movies.scss';
import { useContext } from 'react';
import MovieContext  from '../MovieContext';

const TVSeries = () => {
    const {moviesArray, handleBookmark, loading, searchTerm, searchResults, handleSearch} = useContext(MovieContext);
    const tvSeries = moviesArray.filter((movie) => movie.category === 'TV Series');
    return (
        <>
            {

                <Container className="movies">
                    <Navigation />  
                        <Searchbar 
                            searchResults={searchResults}
                            searchTerm={searchTerm}
                            onSearch={handleSearch}
                            loading={loading}
                        />
                        {
                                loading ? (
                                <Spinner animation="border" size="lg"/>
                            ) : searchTerm && searchResults.length > 0 ? (
                                <div className="results-container">
                                    {
                                        searchResults.map((movie) => {
                                            const {
                                                category,
                                                isBookmarked,
                                                rating,
                                                thumbnail,
                                                title,
                                                year
                                            } = movie

                                            const {small, medium, large } = thumbnail.regular;
                                            return (
                                                <MovieCard 
                                                    category={category}
                                                    isBookmarked={isBookmarked}
                                                    handleBookmark={handleBookmark}
                                                    rating={rating}
                                                    small={small}
                                                    medium={medium}
                                                    larg={large}
                                                    title={title}
                                                    year={year}
                                                />
                                            )
                                        })
                                    }
                                </div>
                            ) : (
                                <>
                                    <h3 className="h3 sub-title movies-title">TV Series</h3>
                                    <Container className="movie-page-container">
                                        {
                                            tvSeries.map((movie) => {
                                                const {
                                                    category, 
                                                    isBookmarked, 
                                                    rating,
                                                    thumbnail,
                                                    title,
                                                    year
                                                } = movie;
                                                
                                                const {small, medium, large } = thumbnail.regular;
                            
                                                return (
                                                    <MovieCard 
                                                        key={title}
                                                        category={category}
                                                        isBookmarked={isBookmarked}
                                                        handleBookmark={handleBookmark}
                                                        rating={rating}
                                                        small={small}
                                                        medium={medium}
                                                        larg={large}
                                                        title={title}
                                                        year={year}
                                                    />
                                                )
                                            })
                                        }
                                    </Container>
                                </>
                            )
                        } 
                </Container>
            }
        </>
    )
}

export default TVSeries;